import { getItemFromLocalStorage } from 'core-framework/window/storage';
import { LocalStorageKey } from 'core-framework/constant/StorageKeys';
import { findTagByQuery } from 'core/utils/domUtils';
import { logWarn } from 'core-framework/util/LogMessage';

export const scrollTo = (x: number, y: number, windowArg = window) => windowArg.scrollTo(x, y);

// This code is not supported in Edge 12 so we default to be 0
export const scrollY = (windowArg = window): number => windowArg.scrollY || 0;

export const scrollToTop = (documentArg = document) => {
    documentArg.body.scrollTop = 0; // For Safari
    documentArg.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

const setScrollRestoration = (windowArg = window) => {
    if (windowArg.history?.scrollRestoration) {
        windowArg.history.scrollRestoration = 'manual';
    }
};

export const restoreScrollPosition = (windowArg = window, localStorage?: Storage) => {
    const scrollData = getItemFromLocalStorage(LocalStorageKey.ACTIVITY_SCROLL_POSITION_KEY, localStorage);
    if (!scrollData) {
        scrollToTop();
        return;
    }

    try {
        const { activityId, x, y } = JSON.parse(scrollData) as { activityId: number; x: number; y: number };
        const activityExists = findTagByQuery(`[data-activity-id="${activityId}"]`);
        if (activityExists) {
            setScrollRestoration(windowArg);
            scrollTo(x, y);
        } else {
            scrollToTop();
        }
    } catch (error) {
        logWarn(`restoreScrollPosition could not process scrollData: ${error}`, 0);
    }
};
